import HomePage from 'Components/HomePage';
import React from 'react';

export const Home = ({ ...props }) => {
  return <HomePage {...props} />;
};
